export const GET_FAMILY_ACCOUNTS = 'GET_FAMILY_ACCOUNTS';
